import React, { useEffect, useRef } from "react"
import { Layout, Page } from "@shopify/polaris"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import withAuthRequired from "components/auth/withAuthRequired"
import "stylesheets/VerdiktApiPage.scss"

/**
 * Verdikt API documentation page with Swagger UI
 * Loads Swagger UI from CDN and displays the OpenAPI specification
 */
const VerdiktApiPage = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const swaggerRef = useRef(null)

  useEffect(() => {
    // Load Swagger UI CSS
    const cssLink = document.createElement("link")
    cssLink.rel = "stylesheet"
    cssLink.href = "https://unpkg.com/swagger-ui-dist@5.11.0/swagger-ui.css"
    document.head.appendChild(cssLink)

    // Load Swagger UI JS
    const script = document.createElement("script")
    script.src = "https://unpkg.com/swagger-ui-dist@5.11.0/swagger-ui-bundle.js"
    script.async = true
    script.onload = () => {
      if (window.SwaggerUIBundle && swaggerRef.current) {
        window.SwaggerUIBundle({
          url: "/api/verdikt-api.yaml",
          dom_id: "#swagger-ui",
          presets: [
            window.SwaggerUIBundle.presets.apis,
            window.SwaggerUIBundle.SwaggerUIStandalonePreset,
          ],
          layout: "BaseLayout",
          deepLinking: true,
          showExtensions: true,
          showCommonExtensions: true,
        })
      }
    }
    document.body.appendChild(script)

    return () => {
      // Cleanup
      document.head.removeChild(cssLink)
      document.body.removeChild(script)
    }
  }, [])

  const handleBack = () => {
    history.push("/developer")
  }

  return (
    <Page
      fullWidth
      title={t("developer_portal:verdikt_api.title", {
        defaultValue: "Verdikt API Documentation",
      })}
      breadcrumbs={[
        {
          content: t("developer_portal:title"),
          onAction: handleBack,
        },
      ]}
    >
      <Layout>
        <Layout.Section>
          <div className="verdiktApiPage">
            <div className="verdiktApiPage__swagger" ref={swaggerRef}>
              <div id="swagger-ui" />
            </div>
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  )
}

export default withAuthRequired(VerdiktApiPage)

